module.exports = {"id":"186148","name":"Ron-Robert Zieler","rating":"79","photo":"./data/images/photos/4/186148.png","club":{"name":"VfB Stuttgart","logo":"./data/images/clubs/VfBStuttgart.png"},"positions":["G"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Ron-RobertZieler0.json
// module id = 3709
// module chunks = 0